import React from "react";
import { Button, Icon, Toast, Modal } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import api from "./api";
import Cookies from "js-cookie";
import ServiceAgreenmentText from "../modules/serviceAgreenmentText";

import "./index.less";

const alert = Modal.alert;

var timer;

class ACLogin extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            iconType: false,
            second: 59,
            secondType: false,
            inputBlur1: true,
            inputBlur2: true,
            inputBlur3: true,
            serviceAgreenmentTextStatus: false, //协议文案展示状态
            mobileNumber: "",
            img: "",
            TPYZMtype: false,
            TPyanzhengma: "",
            recordCode: "",
        };
    }

    componentDidMount() {
        if (window.location.hash.indexOf("mobileNumber") > -1) {
            const search = window.location.hash.split("?")[1];
            if (!search.split("=")[1] || search.split("=")[1] === "null") {
                alert(
                    "提示",
                    "您的慧联账号暂未绑定手机号，无法进行网页签署，请登录远程慧联APP完成签署！",
                    [
                        // { text: 'Cancel', onPress: () => console.log('cancel'), style: 'default' },
                        // { text: 'OK', onPress: () => console.log('ok') },
                    ]
                );
                return;
            }
            this.setState(
                {
                    mobileNumber: search.split("=")[1],
                    inputBlur1: false,
                },
                () => {
                    document.getElementById("shouji").value =
                        search.split("=")[1];
                    document.getElementById("shouji").disabled = true;
                }
            );
        }
    }

    getPhotoValidCode() {
        var shouji = document.getElementById("shouji").value;
        post({
            url: api.getPhotoValidCode,
            data: {
                phoneNumber: shouji,
                businessType: "LOG_IN",
            },
        }).then(
            (res) => {
                // console.log('图片验证码', res);
                if (res.result === "success") {
                    this.setState({
                        // TPYZMtype: true,
                        img: "data:image/jpeg;base64," + res.data,
                    });
                } else {
                    Toast.info("图片验证码获取失败", 1);
                }
            },
            (res) => {
                Toast.info("图片验证码获取失败", 1);
            }
        );
    }

    timerFN = () => {
        const { TPyanzhengma } = this.state;
        var shouji = document.getElementById("shouji").value;
        if (!shouji || shouji.length < 11) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }

        clearInterval(timer);
        let _this = this;
        post({
            url: api.getRegisterCode,
            data: {
                phoneNumber: shouji,
                businessType: "LOG_IN",
                imageCode: TPyanzhengma || "",
            },
        }).then(
            (res) => {
                console.log("验证码", res);
                if (res.result === "success") {
                    _this.setState(
                        {
                            second: 59,
                            secondType: true,
                            recordCode: res.data,
                        },
                        () => {
                            let { second } = _this.state;
                            timer = setInterval(function () {
                                if (second < 0) {
                                    clearInterval(timer);
                                    _this.setState({
                                        secondType: false,
                                    });
                                } else {
                                    _this.setState({
                                        second: second--,
                                    });
                                }
                            }, 1000);
                        }
                    );
                } else if (res.code === "BD001000000998") {
                    clearInterval(timer);
                    this.setState(
                        {
                            secondType: false,
                            TPYZMtype: true,
                        },
                        () => {
                            this.getPhotoValidCode();
                        }
                    );
                    Toast.info("图片验证码填写错误", 2);
                } else if (res.code === "BD001000000997") {
                    clearInterval(timer);
                    this.setState(
                        {
                            secondType: false,
                            TPYZMtype: true,
                        },
                        () => {
                            this.getPhotoValidCode();
                        }
                    );
                    Toast.info("请输入图片验证码", 1);
                } else {
                    this.setState({
                        TPyanzhengma: "",
                    });
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                this.setState({
                    TPyanzhengma: "",
                });
                Toast.info(res.msg, 1);
            }
        );
    };

    focusFN = (type) => {
        if (type === 1) {
            this.setState({
                inputBlur1: false,
            });
        } else if (type === 2) {
            this.setState({
                inputBlur2: false,
            });
        } else {
            this.setState({
                inputBlur3: false,
            });
        }
    };

    blurFN = (type) => {
        if (type === 1) {
            var value = document.getElementById("shouji").value;
            if (!value) {
                this.setState({
                    inputBlur1: true,
                });
            }
        } else if (type === 2) {
            // var value = document.getElementById('TPyanzhengma').value;
            // if(!value){
            //     this.setState({
            //         inputBlur2: true
            //     });
            // }
        } else {
            var value = document.getElementById("yanzhengma").value;
            if (!value) {
                this.setState({
                    inputBlur3: true,
                });
            }
        }
    };

    submit = () => {
        var shouji = document.getElementById("shouji").value;
        var yanzhengma = document.getElementById("yanzhengma").value;
        if (!shouji || shouji.length < 11) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }
        if (!yanzhengma) {
            Toast.info("请填写验证码", 1);
            return;
        }
        if (!this.state.iconType) {
            Toast.info("同意《慧联用户协议》后才可登录", 1);
            return;
        }

        post({
            url: api.webMobileLogin,
            data: {
                // clientIp: window.returnCitySN["cip"],
                messageCode: yanzhengma,
                phoneNumber: shouji,
            },
        }).then(
            (res) => {
                console.log("登录", res);
                if (res.data && res.result === "success") {
                    Cookies.set("session_key", res.data.appstoken);
                    // localStorage.setItem('account',res.data.account);
                    href(
                        `/ACGuideCompact?mobileNumber=${shouji}&tiertype=${res.data.tiertype}&certification=${res.data.certification}`
                    );
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("登录失败", 1);
            }
        );
    };

    render() {
        let {
            iconType,
            second,
            secondType,
            inputBlur1,
            inputBlur2,
            recordCode,
            inputBlur3,
            serviceAgreenmentTextStatus,
            TPYZMtype,
            img,
        } = this.state;
        return (
            <div className="ACLoginBox">
                <h1>手机号登录</h1>
                <div className="importBox">
                    <label htmlFor="shouji">
                        <div
                            className={[
                                "labelTex ",
                                inputBlur1 ? "labelTexSelect" : "",
                            ].join(" ")}
                        >
                            手机号
                        </div>
                        <div className="inputBox">
                            <input
                                id="shouji"
                                type="tel"
                                maxLength="11"
                                onFocus={() => {
                                    this.focusFN(1);
                                }}
                                onBlur={() => {
                                    this.blurFN(1);
                                }}
                            />
                        </div>
                    </label>
                    {/* {TPYZMtype ? (<label htmlFor="TPyanzhengma">
                        <div className={['labelTex ', inputBlur2 ? 'labelTexSelect' : ''].join(' ')}>图片验证码</div>
                        <div className="inputBox">
                            <input id="TPyanzhengma" type="text" onFocus={()=>{this.focusFN(2);}} onBlur={()=>{this.blurFN(2);}} />
                        </div>
                        <div className="second secondText" style={{top: '0.1rem'}} onClick={()=>{
                            this.getPhotoValidCode();
                        }}><img src={img} /></div>
                    </label>) : ''} */}

                    <label htmlFor="yanzhengma">
                        <div
                            className={[
                                "labelTex ",
                                inputBlur3 ? "labelTexSelect" : "",
                            ].join(" ")}
                        >
                            验证码
                        </div>
                        <div className="inputBox">
                            <input
                                id="yanzhengma"
                                type="number"
                                onFocus={() => {
                                    this.focusFN(3);
                                }}
                                onBlur={() => {
                                    this.blurFN(3);
                                }}
                            />
                        </div>
                        {secondType ? (
                            <div>
                                <div className="second secondText">
                                    {second}S
                                </div>
                                <span
                                    style={{
                                        color: "#999",
                                        float: "right",
                                        marginTop: "8px",
                                    }}
                                >
                                    请输入接收到的验证码（编号{recordCode}）
                                </span>
                            </div>
                        ) : (
                            <div
                                className="second"
                                onClick={this.timerFN}
                            >
                                获取验证码
                            </div>
                        )}
                    </label>
                </div>

                {TPYZMtype ? (
                    <div className="TPyanzhengma">
                        <div>
                            <h2>请输入图形验证码</h2>
                            <div className="inputBox">
                                <input
                                    id="TPyanzhengma"
                                    type="text"
                                    placeholder="请输入"
                                />
                                <div
                                    className="imgCodeBox"
                                    onClick={() => {
                                        this.getPhotoValidCode();
                                    }}
                                >
                                    <img src={img} />
                                </div>
                            </div>
                            <Button
                                inline
                                onClick={() => {
                                    this.setState({
                                        TPYZMtype: false,
                                        TPyanzhengma: "",
                                    });
                                }}
                            >
                                取消
                            </Button>
                            <Button
                                inline
                                type="primary"
                                onClick={() => {
                                    var value =
                                        document.getElementById(
                                            "TPyanzhengma"
                                        ).value;
                                    if (!value) {
                                        Toast.info("请填写图片验证码", 1);
                                        return;
                                    }
                                    this.setState(
                                        {
                                            TPYZMtype: false,
                                            TPyanzhengma: value,
                                        },
                                        () => {
                                            this.timerFN();
                                        }
                                    );
                                }}
                            >
                                确定
                            </Button>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                <Button
                    type="primary"
                    onClick={this.submit}
                >
                    登录
                </Button>
                <div className="agreeBox">
                    <label
                        onClick={() => {
                            this.setState({
                                iconType: !iconType,
                            });
                        }}
                    >
                        {iconType ? <Icon type="check" /> : <Icon />}
                        登录即代表同意
                    </label>
                    <a
                        onClick={() => {
                            this.setState({
                                serviceAgreenmentTextStatus: true,
                            });
                        }}
                    >
                        《慧联用户协议》
                    </a>
                </div>
                {serviceAgreenmentTextStatus ? (
                    <ServiceAgreenmentText
                        serviceAgreenmentTextStatus={
                            serviceAgreenmentTextStatus
                        }
                        onQuit={(serviceAgreenmentTextStatus) => {
                            this.setState({
                                serviceAgreenmentTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default ACLogin;



// WEBPACK FOOTER //
// ./src/authCertificateCompact/ACLogin/index.js